import i18n from '../i18n';

/**
 * Service pour traduire les messages d'erreur du backend
 */
const errorTranslationService = {
  /**
   * Traduit un message d'erreur
   * @param {string|Object} error - Message d'erreur ou objet d'erreur
   * @returns {string} Message traduit
   */
  translateErrorMessage: (error) => {
    console.log('[ErrorTranslation] Translating error:', error);
    
    // Si l'erreur est null ou undefined, retourner une chaîne vide
    if (!error) {
      console.log('[ErrorTranslation] Error is null or undefined');
      return '';
    }
    
    // Si l'erreur est une chaîne
    if (typeof error === 'string') {
      console.log('[ErrorTranslation] Error is a string');
      
      // Cas spéciaux pour les messages d'erreur courants en français
      if (error.includes('email est déjà utilisée') || 
          error.includes('adresse email est déjà utilisée') ||
          error.includes('Cette adresse email est déjà utilisée')) {
        console.log('[ErrorTranslation] Detected French email exists error');
        const translation = i18n.t('errors.backend.email already exists', { defaultValue: error });
        console.log('[ErrorTranslation] Translated to:', translation);
        return translation;
      }
      
      const key = `errors.backend.${error}`;
      const translation = i18n.t(key, { defaultValue: error });
      console.log('[ErrorTranslation] String translation:', key, '->', translation);
      return translation;
    }
    
    // Si l'erreur est un objet avec un message
    if (error.message) {
      console.log('[ErrorTranslation] Error is an object with message property');
      
      // Cas spéciaux pour les messages d'erreur courants en français
      if (error.message.includes('email est déjà utilisée') || 
          error.message.includes('adresse email est déjà utilisée') ||
          error.message.includes('Cette adresse email est déjà utilisée')) {
        console.log('[ErrorTranslation] Detected French email exists error in object');
        const translation = i18n.t('errors.backend.email already exists', { defaultValue: error.message });
        console.log('[ErrorTranslation] Translated to:', translation);
        return translation;
      }
      
      const key = `errors.backend.${error.message}`;
      const translation = i18n.t(key, { defaultValue: error.message });
      console.log('[ErrorTranslation] Object message translation:', key, '->', translation);
      return translation;
    }
    
    // Si l'erreur est un objet de réponse API
    if (error.response && error.response.data) {
      console.log('[ErrorTranslation] Error is an API response object');
      const data = error.response.data;
      
      // Si le backend fournit une clé d'erreur (nouveau format)
      if (data.errorKey) {
        console.log('[ErrorTranslation] Error has errorKey:', data.errorKey);
        const translation = i18n.t(data.errorKey, { defaultValue: data.msg || data.message || 'Une erreur est survenue' });
        console.log('[ErrorTranslation] Translated with errorKey to:', translation);
        return translation;
      }
      
      // Si le backend fournit un message dans le format msg (ancien format)
      if (data.msg) {
        console.log('[ErrorTranslation] Error has msg property:', data.msg);
        
        // Cas spéciaux pour les messages d'erreur courants en français
        if (data.msg.includes('email est déjà utilisée') || 
            data.msg.includes('adresse email est déjà utilisée') ||
            data.msg.includes('Cette adresse email est déjà utilisée')) {
          console.log('[ErrorTranslation] Detected French email exists error in msg');
          const translation = i18n.t('errors.backend.email already exists', { defaultValue: data.msg });
          console.log('[ErrorTranslation] Translated to:', translation);
          return translation;
        }
        
        const key = `errors.backend.${data.msg}`;
        const translation = i18n.t(key, { defaultValue: data.msg });
        console.log('[ErrorTranslation] Msg translation:', key, '->', translation);
        return translation;
      }
      
      // Si le backend fournit un message dans le format message
      if (data.message) {
        console.log('[ErrorTranslation] Error has message property:', data.message);
        
        // Cas spéciaux pour les messages d'erreur courants en français
        if (data.message.includes('email est déjà utilisée') || 
            data.message.includes('adresse email est déjà utilisée') ||
            data.message.includes('Cette adresse email est déjà utilisée')) {
          console.log('[ErrorTranslation] Detected French email exists error in message');
          const translation = i18n.t('errors.backend.email already exists', { defaultValue: data.message });
          console.log('[ErrorTranslation] Translated to:', translation);
          return translation;
        }
        
        const key = `errors.backend.${data.message}`;
        const translation = i18n.t(key, { defaultValue: data.message });
        console.log('[ErrorTranslation] Message translation:', key, '->', translation);
        return translation;
      }
      
      // Si le backend fournit un message dans le format error
      if (data.error) {
        console.log('[ErrorTranslation] Error has error property:', data.error);
        
        // Cas spéciaux pour les messages d'erreur courants en français
        if (data.error.includes('email est déjà utilisée') || 
            data.error.includes('adresse email est déjà utilisée') ||
            data.error.includes('Cette adresse email est déjà utilisée')) {
          console.log('[ErrorTranslation] Detected French email exists error in error property');
          const translation = i18n.t('errors.backend.email already exists', { defaultValue: data.error });
          console.log('[ErrorTranslation] Translated to:', translation);
          return translation;
        }
        
        const key = `errors.backend.${data.error}`;
        const translation = i18n.t(key, { defaultValue: data.error });
        console.log('[ErrorTranslation] Error property translation:', key, '->', translation);
        return translation;
      }
    }
    
    // Si l'erreur est un objet sans message reconnaissable, retourner un message par défaut
    console.log('[ErrorTranslation] Unrecognized error format, using default message');
    const defaultMessage = i18n.t('errors.unknown', 'Une erreur inconnue est survenue');
    console.log('[ErrorTranslation] Default message:', defaultMessage);
    return defaultMessage;
  }
};

export default errorTranslationService;